import AddOcppTagRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/add-ccpp-tag-request-dto";
import AddChargingScheduleRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/add-charging-schedule-request-dto";
import AddEvChargerRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/add-ev-charger-request-dto";
import ChargingSessionGraphPointRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/charging-session-graph-point-request-dto";
import ExportChargingHistoryRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/export-charging-history-request-dto";
import GenericPageChargingSessionRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/generic-page-charging-session-request-dto";
import IListAllEvChargersRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/list-all-ev-chargers-request-dto";
import RegisterLightweightUserRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/register-lightweight-user-request-dto";
import IRfidSummaryRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/rfid-summary-request-dto";
import StartSessionRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/start-session-request-dto";
import StopSessionRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/stop-session-request-dto";
import IUpdateChargingTimerRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/update-charging-timer-request-dto";
import UpdateEVChargerRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/update-ev-charger-request-dto";
import UpdateOcppTagRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/update-ocpp-tag-request-dto";
import IActiveChargingSessionResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/active-charging-session-response-dto";
import AddChargingScheduleManagerOutput from "../../../shared/oversight-core/dtos/response-dtos/add-charging-schedule-manager-output";
import AddEvChargerResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/add-ev-charger-response-dto";
import AddOcppTagResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/add-ocpp-tag-response-dto";
import ChargingSessionGraphPointResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/charging-session-graph-point-response-dto";
import IChargingTimerResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/charging-timer-response-dto";
import DeleteChargingScheduleManagerOutput from "../../../shared/oversight-core/dtos/response-dtos/delete-charging-schedule-manager-output";
import EVChargerDashboardResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/ev-charger-dashboard-response-dto";
import IListAllEvChargersResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/list-all-ev-chargers-response-dto";
import OcppTagResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/ocpp-tag-response-dto";
import RegisterLightweightUserResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/register-lightweight-user-response-dto";
import IRfidSummaryResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/rfid-summary-response-dto";
import StartSessionResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/start-session-response-dto";
import StopSessionResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/stop-session-response-dto";
import UpdateChargingScheduleStatusManagerOutput from "../../../shared/oversight-core/dtos/response-dtos/update-charging-schedule-status-manager-output";
import UpdateEVChargerResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/update-ev-charger-response-dto";
import UpdateOcppTagResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/update-ocpp-tag-response-dto";
import IValidateOcppTagResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/validate-ocpp-tag-response-dto";
import ViewChargingSchedulesManagerOutput from "../../../shared/oversight-core/dtos/response-dtos/view-charging-schedules-manager-output";
import IViewChargingSessionsResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-charging-sessions-response-dto";
import ViewEVChargerCatalogManagerOutputResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-ev-charger-catalog-response-dto";
import { ViewEvChargerResponseDTO } from "../../../shared/oversight-core/dtos/response-dtos/view-ev-charger-response-dto";
import { transformErrorResponse } from "../../../shared/oversight-core/utils/transformErrorResponse";
import { rootApi } from "../apiManager";

export const evChargerAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    addEvCharger: builder.mutation<
      AddEvChargerResponseDTO,
      AddEvChargerRequestDTO
    >({
      transformErrorResponse,
      query(data) {
        return {
          url: `ev-charger/register`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["EvCharger"],
    }),
    updateEvCharger: builder.mutation<
      UpdateEVChargerResponseDTO,
      UpdateEVChargerRequestDTO
    >({
      transformErrorResponse,
      query(data) {
        return {
          url: `ev-charger/${data.evChargerId}/update`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["EvCharger"],
    }),
    getEvChargerCatalog: builder.query<
      ViewEVChargerCatalogManagerOutputResponseDTO,
      void
    >({
      transformErrorResponse,
      query() {
        return {
          url: `ev-charger/catalog`,
          method: "GET",
        };
      },
    }),
    viewEvCharger: builder.query<
      ViewEvChargerResponseDTO,
      {
        evChargerId: string;
      }
    >({
      transformErrorResponse,
      query({ evChargerId }) {
        return {
          url: `ev-charger/${evChargerId}/view`,
          method: "GET",
        };
      },
    }),
    createEvChargerSchedule: builder.mutation<
      AddChargingScheduleManagerOutput,
      AddChargingScheduleRequestDTO
    >({
      transformErrorResponse,
      query(data) {
        return {
          url: `ev-charger/schedules`,
          method: "POST",
          body: data,
        };
      },
    }),
    viewEvChargerScheduleList: builder.query<
      ViewChargingSchedulesManagerOutput,
      {
        evChargerId: string;
      }
    >({
      transformErrorResponse,
      query({ evChargerId }) {
        return {
          url: `ev-charger/schedules`,
          method: "GET",
          params: {
            evChargerId,
          },
        };
      },
    }),
    changeEvChargerScheduleState: builder.mutation<
      UpdateChargingScheduleStatusManagerOutput,
      {
        scheduleId: string;
        status: string;
      }
    >({
      transformErrorResponse,
      query({ scheduleId, status }) {
        return {
          url: `ev-charger/schedules/${scheduleId}/status`,
          method: "PATCH",
          body: {
            status,
          },
        };
      },
    }),
    deleteEvChargerSchedule: builder.mutation<
      DeleteChargingScheduleManagerOutput,
      {
        scheduleId: string;
      }
    >({
      transformErrorResponse,
      query({ scheduleId }) {
        return {
          url: `ev-charger/schedules/${scheduleId}/delete`,
          method: "DELETE",
        };
      },
    }),
    viewEvChargerSessionList: builder.query<
      IViewChargingSessionsResponseDTO,
      GenericPageChargingSessionRequestDTO
    >({
      transformErrorResponse,
      query(params) {
        return {
          url: `ev-charger/sessions`,
          method: "GET",
          params,
        };
      },
    }),
    viewEvChargerSessionGraph: builder.query<
      ChargingSessionGraphPointResponseDTO[],
      ChargingSessionGraphPointRequestDTO
    >({
      transformErrorResponse,
      query(params) {
        return {
          url: `ev-charger/sessions/graph`,
          method: "GET",
          params,
        };
      },
    }),
    chargingSessionStart: builder.mutation<
      StartSessionResponseDTO,
      StartSessionRequestDTO
    >({
      transformErrorResponse,
      query(data) {
        return {
          url: `ev-charger/sessions/start`,
          method: "POST",
          body: data,
        };
      },
    }),
    chargingSessionStop: builder.mutation<
      StopSessionResponseDTO,
      StopSessionRequestDTO
    >({
      transformErrorResponse,
      query(data) {
        return {
          url: `ev-charger/sessions/stop`,
          method: "POST",
          body: data,
        };
      },
    }),
    viewEvChargerSessionsByRfid: builder.query<
      IRfidSummaryResponseDTO[],
      IRfidSummaryRequestDTO
    >({
      transformErrorResponse,
      query(params) {
        return {
          url: `ev-charger/sessions/by-rfid`,
          method: "GET",
          params,
        };
      },
    }),
    viewEvChargerSessionActive: builder.query<
      IActiveChargingSessionResponseDTO,
      void
    >({
      transformErrorResponse,
      query() {
        return {
          url: `ev-charger/sessions/active`,
          method: "GET",
        };
      },
    }),
    listAllEvChargers: builder.query<
      IListAllEvChargersResponseDTO,
      IListAllEvChargersRequestDTO
    >({
      transformErrorResponse,
      query(params) {
        return {
          url: `ev-charger/view`,
          method: "GET",
          params,
        };
      },
      providesTags: ["EvCharger"],
    }),
    removeEvCharger: builder.mutation<
      void,
      {
        evChargerId: string;
      }
    >({
      transformErrorResponse,
      query({ evChargerId }) {
        return {
          url: `ev-charger/${evChargerId}/unregister`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["EvCharger"],
    }),
    evChargerDashboard: builder.query<
      EVChargerDashboardResponseDTO,
      { year?: number; month?: number }
    >({
      transformErrorResponse,
      query({ year, month }) {
        return {
          url: `ev-charger/dashboard`,
          method: "GET",
          params: {
            year,
            month,
          },
        };
      },
    }),
    addRFIDTag: builder.mutation<AddOcppTagResponseDTO, AddOcppTagRequestDTO>({
      transformErrorResponse,
      query(data) {
        return {
          url: `ev-charger/ocpp-tags`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["OcppTag"],
    }),
    updateRFIDTag: builder.mutation<
      UpdateOcppTagResponseDTO,
      UpdateOcppTagRequestDTO
    >({
      transformErrorResponse,
      query(data) {
        return {
          url: `ev-charger/ocpp-tags/${data.ocppTagId}`,
          method: "PATCH",
          body: {
            note: data.note,
            blocked: data.blocked,
            consumerId: data.consumerId,
          },
        };
      },
      invalidatesTags: ["OcppTag"],
    }),
    removeRFIDTag: builder.mutation<
      void,
      {
        ocppTagId: string;
      }
    >({
      transformErrorResponse,
      query({ ocppTagId }) {
        return {
          url: `ev-charger/ocpp-tags/${ocppTagId}/delete`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["OcppTag"],
    }),
    viewRFIDList: builder.query<OcppTagResponseDTO[], { search?: string }>({
      transformErrorResponse,
      query({ search }) {
        return {
          url: `ev-charger/ocpp-tags`,
          method: "GET",
          params: { search },
        };
      },
      providesTags: ["OcppTag"],
    }),
    lookupRfidTag: builder.query<
      IValidateOcppTagResponseDTO,
      { idTag: string }
    >({
      transformErrorResponse,
      query({ idTag }) {
        return {
          url: `ev-charger/ocpp-tags/validate`,
          method: "GET",
          params: { idTag },
        };
      },
      providesTags: ["OcppTag"],
    }),
    registerLightweightUser: builder.mutation<
      RegisterLightweightUserResponseDTO,
      RegisterLightweightUserRequestDTO
    >({
      transformErrorResponse,
      query(data) {
        return {
          url: `user/lightweight/register`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["Consumer"],
    }),
    viewChargingTimer: builder.query<
      IChargingTimerResponseDTO,
      { evChargerId: string }
    >({
      transformErrorResponse,
      query({ evChargerId }) {
        return {
          url: `ev-charger/${evChargerId}/charging-timer`,
          method: "GET",
        };
      },
    }),
    updateChargingTimer: builder.mutation<
      IChargingTimerResponseDTO,
      IUpdateChargingTimerRequestDTO
    >({
      transformErrorResponse,
      query(data) {
        return {
          url: `ev-charger/${data.evChargerId}/charging-timer`,
          method: "PUT",
          body: {
            startTime: data.startTime,
            endTime: data.endTime,
          },
        };
      },
    }),
    exportChargingHistoryReport: builder.mutation<
      Blob,
      ExportChargingHistoryRequestDTO
    >({
      transformErrorResponse,
      query(params) {
        return {
          url: `ev-charger/sessions/export`,
          method: "GET",
          params,
          responseHandler: (response) => response.blob(),
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddEvChargerMutation,
  useUpdateEvChargerMutation,
  useRemoveEvChargerMutation,
  useGetEvChargerCatalogQuery,
  useViewEvChargerQuery,
  useCreateEvChargerScheduleMutation,
  useViewEvChargerScheduleListQuery,
  useChangeEvChargerScheduleStateMutation,
  useDeleteEvChargerScheduleMutation,
  useViewEvChargerSessionListQuery,
  useViewEvChargerSessionGraphQuery,
  useViewEvChargerSessionsByRfidQuery,
  useViewEvChargerSessionActiveQuery,
  useListAllEvChargersQuery,
  useEvChargerDashboardQuery,
  useAddRFIDTagMutation,
  useUpdateRFIDTagMutation,
  useRemoveRFIDTagMutation,
  useViewRFIDListQuery,
  useLazyLookupRfidTagQuery,
  useRegisterLightweightUserMutation,
  useViewChargingTimerQuery,
  useUpdateChargingTimerMutation,
  useChargingSessionStartMutation,
  useChargingSessionStopMutation,
  useExportChargingHistoryReportMutation,
} = evChargerAPI;
